﻿<script setup>
    const props = defineProps({
        title: String,
        to: String,
        label: String,
        flat: Boolean,
        dense: Boolean,
        icon: {
            type: String,
            default: 'done'
        }
    });

    const emit = defineEmits(['click']);

    function click() {
        emit('click');
    }
</script>

<template>
    <q-btn 
        :dense="dense"
        :round="!flat"
        :flat="flat"
        :outline="flat"
        :size="flat ? 'md' : 'sm'" 
        color="positive" 
        :icon="icon" 
        :title="title || 'Ok'"
        :label="flat ? (label || 'Ok') : ''"
        @click="click"
        :to="to" />
</template>